/**
 * Bankruptcy Watch — shared metadata (chapter labels, outcome tags).
 */

export const CHAPTER_META = {
  7: {
    label: "Chapter 7",
    tagline: "Liquidation",
    color: "#E74C3C",
    explanation:
      "Non-exempt assets are sold by a court-appointed trustee and distributed to creditors. Automatic stay ends at discharge (typically 4–6 months). Consumer debts are broadly discharged unless § 523 applies.",
  },
  11: {
    label: "Chapter 11",
    tagline: "Reorganization",
    color: "#F39C12",
    explanation:
      "Debtor stays in possession and reorganizes under court supervision. Enforcement is stayed until confirmation of a plan or dismissal. Judgment creditors may vote on the plan.",
  },
  13: {
    label: "Chapter 13",
    tagline: "Wage-Earner Plan",
    color: "#4CA6FF",
    explanation:
      "Debtor keeps assets and repays creditors from future income under a 3–5-year plan. Stay extends to co-debtors on consumer debts. Enforcement halts until dismissal or completion.",
  },
};

export const chapterInfo = (chapter) => {
  const key = String(chapter || "").replace(/^Chapter\s*/i, "").trim();
  return CHAPTER_META[Number(key)] || null;
};

export const OUTCOMES = [
  {
    key: "discharge",
    title: "Discharge Granted",
    color: "var(--color-success)",
    icon: "check",
    body:
      "Consumer debts wiped. Judgment lien may still attach to real property recorded before filing (see 11 U.S.C. § 522(f)).",
  },
  {
    key: "dismissed",
    title: "Case Dismissed",
    color: "#F39C12",
    icon: "arrow-return",
    body:
      "Enforcement rights are fully restored. Recover accrued interest for the stayed period and re-open all collection actions.",
  },
  {
    key: "conversion",
    title: "Converted to Chapter 7",
    color: "#E74C3C",
    icon: "shuffle",
    body:
      "A Ch. 13 → Ch. 7 conversion triggers a fresh 341 meeting and often surfaces new assets. Verify surviving liens.",
  },
];
